<template>
  <div id="app" class="app-empty onboarding">
    <section>
      <div class="onboarding-container">
        <div class="onboarding-header">
          <logo full />
        </div>
      </div>
    </section>
    <nuxt />
    <portal-target name="root" />
    <refresh-notification />
  </div>
</template>
<script>
  import Logo from '../components/shared/Logo.vue';
  import RefreshNotification from '../components/shared/RefreshNotification.vue';

  export default {
    components: {
      Logo,
      RefreshNotification,
    },
  };
</script>
